export class TableDto {
  id: string;
  name: string;
  userId: string;
  shared: boolean;
  jsonData: string;
}
